export function phaseTexts(phase, t) {
  let result = {
    phase: phase,
    description: phase,
  };
  if (!phase) return null;

  if (phase) {
    switch (phase.toLowerCase()) {
      // case "rejected":
      case "interested":
        result = {
          phase: t("phase.interested"),
          description: t("phase.interested.text"),
        };
        break;
      case "sharedcandidates":
      case "screening":
        result = {
          phase: t("phase.screening"),
          description: t("phase.screening.text"),
        };
        break;
      case "viewing":
        result = {
          phase: t("phase.viewing"),
          description: t("phase.viewing.text"),
        };
        break;
      case "videoviewing":
        result = {
          phase: t("phase.videoviewing"),
          description: t("phase.videoviewing.text"),
        };
        break;
      case "providingoption":
        result = {
          phase: t("phase.assigned"),
          description: t("phase.assigned.text"),
        };
        break;
      case "screeninginvited":
        result = {
          phase: t("phase.screening_invited"),
          description: t("phase.screening_invited.text"),
        };
        break;
      case "datakeepercompleted":
        result = {
          phase: t("phase.datakeeper_completed"),
          description: t("phase.datakeeper_completed.text"),
        };
        break;
      case "datakeeperinvited":
        result = {
          phase: t("phase.datakeeper_invited"),
          description: t("phase.datakeeper_invited.text"),
        };
        break;
      case "checkin":
        result = {
          phase: t("phase.checkin"),
          description: t("phase.checkin.text"),
        };
        break;
      case "contract":
        result = {
          phase: t("phase.contract"),
          description: t("phase.contract.text"),
        };
        break;
      case "rented":
        result = {
          phase: t("phase.rented"),
          description: t("phase.rented.text"),
        };
        break;
      default:
        console.log(phase);
        break;
    }
  }
  return result;
}

export function yesNoConverter(yesNo, t) {
  let result = yesNo;
  if (yesNo) {
    switch (yesNo.toLowerCase()) {
      case "yes":
        result = t("Yes");
        break;
      case "no":
        result = t("No");
        break;
      default:
        console.log(yesNo);
        break;
    }
  }
  return result;
}

export function allowedToText(allowedTo, t) {
  let result = allowedTo;
  if (allowedTo) {
    switch (allowedTo.toLowerCase()) {
      case "allowed":
        result = t("Allowed");
        break;
      case "not allowed":
        result = t("Not Allowed");
        break;
      default:
        console.log(allowedTo);
        break;
    }
  }
  return result;
}

export function energylabelConverter(label) {
  let result = label;
  if (label) {
    switch (label.toLowerCase()) {
      case "a++++-label":
        result = "A++++";
        break;
      case "a+++-label":
        result = "A+++";
        break;
      case "a++-label":
        result = "A++";
        break;
      case "a+-label":
        result = "A+";
        break;
      case "a-label":
        result = "A";
        break;
      case "b-label":
        result = "B";
        break;
      case "c-label":
        result = "C";
        break;
      case "d-label":
        result = "D";
        break;
      case "e-label":
        result = "E";
        break;
      case "f-label":
        result = "F";
        break;
      case "g-label":
        result = "G";
        break;
      default:
        console.log(label);
        break;
    }
  }
  return result;
}

export function rentalPeriodConverter(rentalPeriod, t) {
  let result = rentalPeriod;
  if (rentalPeriod) {
    switch (rentalPeriod.toLowerCase()) {
      case "bepaalde tijd":
        result = t("rentalperiod.fixed");
        break;
      case "onbepaalde tijd":
        result = t("rentalperiod.indefinite");
        break;
      case "bepaalde tijd met optie tot onbepaalde tijd":
        result = t("rentalperiod.with_option");
        break;
      default:
        console.log(rentalPeriod);
        break;
    }
  }
  return result;
}

export function outdoorSpaceToText(outdoorSpace) {
  let result = outdoorSpace;
  if (outdoorSpace) {
    switch (outdoorSpace.toLowerCase()) {
      case "allowed":
        result = "Toegestaan";
        break;
      case "not allowed":
        result = "Niet toegestaan";
        break;
      default:
        console.log(outdoorSpace);
        break;
    }
  }
  return result;
}

export function constructionTypeConverter(constructionType, t) {
  let result = constructionType;
  if (constructionType) {
    switch (constructionType.toLowerCase()) {
      case "existing building":
        result = t("Existing Building");
        break;
      case "new construction":
        result = t("New Construction");
        break;
      default:
        console.log(constructionType);
        break;
    }
  }
  return result;
}

export function monthlyRentConverter(monthlyRent, t) {
  let result = monthlyRent;
  if (monthlyRent) {
    switch (monthlyRent.toLowerCase()) {
      case "1.5 x monthly rent":
        result = t(monthlyRent);
        break;
      case "1 x monthly rent":
        result = t(monthlyRent);
        break;
      case "2 x monthly rent":
        result = t(monthlyRent);
        break;
      case "3 x monthly rent":
        result = t(monthlyRent);
        break;
      case "not applicable":
        result = t(monthlyRent);
        break;
      default:
        console.log(monthlyRent);
        break;
    }
  }
  return result;
}

export function excludedIncludedConverter(inlcusion, t) {
  let result = inlcusion;
  if (inlcusion) {
    switch (inlcusion.toLowerCase()) {
      case "included":
        result = t("Included");
        break;
      case "excluded":
        result = t("Excluded");
        break;
      default:
        console.log(inlcusion);
        break;
    }
  }
  return result;
}

export function locationConverter(text) {
  let replacements = {
    test: "test",
  };
  return replaceWords(text, replacements);
}
export function amenitiesConverter(text, t) {
  let replacements = {
    "Shower cubicle": t("Shower Cubicle"),
    "Double sinks": t("Double Sinks"),
    "Walk-in shower": t("Walk-in Shower"),
    Jacuzzi: t("Jacuzzi"),
    Bathtub: t("Bathtub"),
    Sauna: t("Sauna"),
    Toilet: t("Toilet"),
    Washbasin: t("Washbasin"),
  };
  return replaceWords(text, replacements);
}
export function outdoorConverter(text, t) {
  let replacements = {
    Balcony: t("Balcony"),
    "Roof terrace": t("Roof Terrace"),
    "French balcony": t("French Balcony"),
    Terrace: t("Terrace"),
    Garden: t("Garden"),
    "Not applicable": t("Not Applicable"),
  };
  return replaceWords(text, replacements);
}
export function parkingConverter(text, t) {
  let replacements = {
    "Public parking": t("Public Parking"),
    "Own parking spot": t("Own Parking Spot"),
    "Indoor garage": t("Indoor Garage"),
  };
  return replaceWords(text, replacements);
}

export function replaceText(allText, textToReplace, replaceWith) {
  return allText?.replace(RegExp(textToReplace, "g"), replaceWith);
}

function replaceWords(text, replacements) {
  for (let [oldWord, newWord] of Object.entries(replacements)) {
    let regex = new RegExp(oldWord, "g");
    text = text?.replace(regex, newWord);
  }
  return text;
}
